import { EnrollmentStatus } from '@spike/payments-model';

export enum salesReportItemvalueType {
    Quantity = 'Quantity',
    Money = 'Money'
}

const Formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
});

export const isNegativeSalesReportItemValue = (value: number | undefined) => {
    if (value && value > 0) {
        return false;
    } else {
        return true;
    }
};

export const formatSalesReportItemValue = (value: number | undefined, type: salesReportItemvalueType) => {
    if (!value) {
        if (type === salesReportItemvalueType.Quantity) {
            return '0';
        } else {
            return '$0.00';
        }
    } else {
        return isNegativeSalesReportItemValue(value)
            ? '(' + Formatter.format(value).replaceAll('-', '') + ')'
            : type === salesReportItemvalueType.Quantity
            ? value
            : Formatter.format(value);
    }
};

export const isNewAccount = (status: EnrollmentStatus | undefined): boolean => {
    return status?.verificationStatus !== undefined;
};

export const formatPayoutAmount = (amount: number | string): string => {
    const value = Number(String(amount).replace(/,/g, ''));
    return Formatter.format(Number.isFinite(value) ? value : 0);
};

export const isPayoutNowMarketplaceEnabled = (marketplaceId: number | undefined): boolean => {
    const enabledMarketplaceIds = (process.env.REACT_APP_PAYOUT_NOW_MARKETPLACE_IDS || '')
        .split(',')
        .map(id => id.replaceAll(/\D/g, ''))
        .filter(id => id !== '')
        .map(id => Number(id));

    return (
        marketplaceId !== undefined &&
        (enabledMarketplaceIds.length === 0 || enabledMarketplaceIds.includes(marketplaceId))
    );
};
